import React, { useEffect, useState } from 'react';
import Navigation from './Navigation';
import "./Pl.css"
import { FaPlay } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const Pl = () => {
  const [activeButton, setActiveButton] = useState('video');
  const [mainSrc, setMainSrc] = useState('assets/Mussoorie 1.mp4');
  const [isVideo, setIsVideo] = useState(true);
  const [plotsLeft, setPlotsLeft] = useState(34);

  useEffect(() => {
    document.body.classList.add('bg-white');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateNumber();
          observer.unobserve(entry.target); // Stop observing after animation starts
        }
      });
    });

    observer.observe(document.querySelector('.number'));

    function animateNumber() {
      const startValue = 34;
      const endValue = 26;
      const duration = 3000;
      const stepTime = Math.abs(Math.floor(duration / (startValue - endValue)));

      let currentValue = startValue;

      const step = () => {
        setPlotsLeft(currentValue);
        if (currentValue > endValue) {
          currentValue--;
          setTimeout(step, stepTime);
        }
      };

      step();
    }

    return () => observer.disconnect(); // Cleanup observer on unmount
  }, []);

  const handleThumbnailClick = (type, src) => {
    setIsVideo(type === 'video');
    setMainSrc(src);
  };

  const handleButtonClick = (button) => {
    setActiveButton(button);
    setIsVideo(button === 'video');
    setMainSrc(button === 'video' ? 'assets/Mussoorie 1.mp4' : 'assets/M6.jpg');
  };

  return (
    <>
    <Helmet>
        <title>Prime Location - Exclusive Mountain Plots near Bhatta Waterfall</title>
        <meta name="description" content="Discover prime plots in Mussoorie near Bhatta Waterfall with breathtaking mountain views, exclusive trekking trails, and a serene environment." />
        <meta name="keywords" content="Mussoorie plots, Bhatta Waterfall, mountain views, prime location, trekking trails, peaceful living, investment opportunity" />
        <meta name="robots" content="index,follow" />
        <meta property="og:title" content="Prime Location - Mountain Plots for Sale near Bhatta Waterfall" />
        <meta property="og:description" content="Get your piece of paradise in Mussoorie. Limited plots available with beautiful mountain views and exclusive trekking options." />
        <meta property="og:image" content="assets/Mussoorie 1.mp4" />
        <meta property="og:url" content="https://gridradhika.netlify.app" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <Navigation />

      <div className="primel">
        <div className="pvheading">
          <button
            id="videoBtn"
            className={`button ${activeButton === 'video' ? 'active' : ''}`}
            onClick={() => handleButtonClick('video')}
          >
            Videos
            <div className="line"></div>
            <div className="line"></div>
          </button>
          <button
            id="photoBtn"
            className={`button ${activeButton === 'photo' ? 'active' : ''}`}
            onClick={() => handleButtonClick('photo')}
          >
            Photos
            <div className="line"></div>
            <div className="line"></div>
          </button>
        </div>

        <div className="main-slider-container">
          <div className="main-slider">
            {isVideo ? (
              <video id="mainVideo" src={mainSrc} controls autoPlay muted playsInline />
            ) : (
              <img id="mainPhoto" src={mainSrc} alt="Main Photo" />
            )}
          </div>
        </div>

        {activeButton === 'video' ? (
          <div className="thumbnail-container video-thumbnails">

            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/M8.jpg"
                alt="Video 1"
                onClick={() => handleThumbnailClick('video', 'assets/Mussoorie 1.mp4')}
              />
              <i className="fa-solid fa-play play-icon"   onClick={() => handleThumbnailClick('video', 'assets/Mussoorie 1.mp4')}>
              <FaPlay/>
              </i>
            </div>

            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/M5.jpg"
                alt="Video 2"
                onClick={() => handleThumbnailClick('video', 'assets/Mussoorie 2.mp4')}
              />
              <i className="fa-solid fa-play play-icon"     onClick={() => handleThumbnailClick('video', 'assets/Mussoorie 2.mp4')}>
              <FaPlay/>
              </i>
            </div>

            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/M1.jpg"
                alt="Video 3"
                onClick={() => handleThumbnailClick('video', 'assets/Mussoorie 3.mp4')}
              />
              <i className="fa-solid fa-play play-icon"  onClick={() => handleThumbnailClick('video', 'assets/Mussoorie 3.mp4')}>
              <FaPlay/>
              </i>
            </div>
            
          </div>
        ) : (
          <div className="thumbnail-container photo-thumbnails">
            <img
              className="thumbnail"
              data-type="photo"
              src="assets/M1.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M1.jpg')}
            />
            <img
              className="thumbnail"
              data-type="photo"
              src="assets/M2.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M2.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/M6.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M3.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/M9.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M4.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/M5.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M5.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/M6.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M6.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/M7.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M7.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/M8.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M8.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/M9.jpg"
              alt="Mussoorie Uttarakhand Images"
              onClick={() => handleThumbnailClick('photo', 'assets/M9.jpg')}
            />
          </div>
        )}
      </div>

      <div className="primecards">
        <div className="descpcards">

          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Serene Mountain Views</h5>
              <h6 className="card-subtitle mb-2 text-muted">Discover breathtaking mountain vistas right from your doorstep.</h6>
            </div>
          </div>


          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Prime Location</h5>
              <h6 className="card-subtitle mb-2 text-muted">Only 300 meters from the serene Bhatta Waterfall – a walk away from nature.</h6>
            </div>
          </div>


          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Exclusive Trekking Trails</h5>
              <h6 className="card-subtitle mb-2 text-muted">Enjoy exclusive trekking options and explore the untouched beauty of Mussoorie.</h6>
            </div>
          </div>

          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Limited Population, Unlimited Peace</h5>
              <h6 className="card-subtitle mb-2 text-muted">Experience tranquility with low population density – your perfect retreat.</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Secure Your Slice of Paradise</h5>
              <h6 className="card-subtitle mb-2 text-muted">Selling fast – 10-12 plots already booked! Don’t miss your chance.</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Close to Nature</h5>
              <h6 className="card-subtitle mb-2 text-muted">Immerse yourself in the serene, lush surroundings of the mountains.</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Ideal Investment Opportunity</h5>
              <h6 className="card-subtitle mb-2 text-muted">A prime investment in a serene and rapidly developing area.</h6>
            </div>
          </div>

        </div>
      </div>

      <div className="primelfoot">
        <div className="googlemaps">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d859.9979798057003!2d78.07292026958736!3d30.436330998420548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzDCsDI2JzEwLjgiTiA3OMKwMDQnMjQuOCJF!5e0!3m2!1sen!2sin!4v1722691691743!5m2!1sen!2sin"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="number">
          <p>Only <span>{plotsLeft}</span> Plots Left</p>
        </div>
        <div className="contactlink">
          <a href="/contact">Book Now!!</a>
        </div>
        <div className="naksha">

        <img class="nakshaimg"  src="assets/BHATTA FOLL PLOTTING PLAN_page-0001.jpg" />
        </div>
      </div>
    </>
  );
};

export default Pl;
